import React, { useEffect, useState } from 'react';
import {useDataVizContext} from '../../context/ContextDataViz';
import {transformData} from './utilsSunburst';
import SunBurstComponent from '../SunburstSimple';
import { Spinner } from '../../../../Components/Spinner/Spinner';
import { EmptyState } from '../../../../Components/EmptyState/EmptyState';
import { Article } from '../../../../Components/Article/Article';

export default function SunburstContainerData() {

	const [transformedData, settransformedData] = useState<any>(null);
	const {
		dataVizAggregate,isLoading,
		noDataForAccount,
		orderBy
	} = useDataVizContext();

	useEffect(()=> {
		if(dataVizAggregate && !isLoading){
			const newData: any = transformData(dataVizAggregate.starts);
			settransformedData(newData);
		}
	},[dataVizAggregate,isLoading]);

	return (
		<>
			{isLoading && 
				<Article innerSize='l' hasMargin={false}>
					<Spinner size="l" display="block" verticalSize="xl" />
				</Article>
			} 
			{noDataForAccount && !isLoading &&
				<Article innerSize='l' hasMargin={false}>
					<EmptyState
						title="No data yet"
						text="Please contact an administrator for more information"
						textSize='xl'
						verticalSize='l'
						imageUrl='/Assets/empty_warn_1.svg'
					/>
				</Article>
			}
			{!isLoading && transformedData && !noDataForAccount && 
				<Article hasMargin={false} hasPadding={false}>
					<SunBurstComponent 
						dataIsEmpty={dataVizAggregate?.starts?.length === 0} 
						transformedData={transformedData} 
						orderBy={orderBy || undefined}
					/>
				</Article>
			}
		</>
	);
}
